export const makeSearchParamsString = ({ searchParams }) => {
  const urlSearchParams = new URLSearchParams();

  Object.entries(searchParams).forEach(([name, value]) => {
    urlSearchParams.set(name, value);
  });

  urlSearchParams.sort();

  return urlSearchParams.toString();
};
